import { defineNuxtPlugin, refreshNuxtData, useRoute } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const preview = (route.query.preview) ? route.query.preview === 'true' : undefined
  const secret = (preview) ? (route.query.secret) ? route.query.secret as string : undefined : undefined

  if (preview) {
    nuxtApp.hook('page:finish', () => {
      refreshNuxtData()
    })
  }

  return { provide: { preview, secret } }
})
